<span *ngIf="content"
      class="{{ classes || 'text-primary' }}"
      matTooltipClass="px-4 py-2 text-white text-sm"
      [matTooltip]="content">
  <i class="fas fa-info-circle"></i>
</span>
